import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'playground:overview',
    name: 'Playground Overview',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'playground.goals-table',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'playground.open-assistant-metric',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
        ],
      },
    },
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
